import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="privacy-container">
        <section className="privacy-hero">
          <h1>Privacy Policy</h1>
          <p className="privacy-updated">Last Updated: December 15, 2025</p>
        </section>
        
        <section className="privacy-content">
          <div className="privacy-section">
            <p className="privacy-intro">
              This Privacy Policy explains how Aspen Quick Care ("we," "us," or "our") collects, uses, and protects your information when you visit our website or interact with us online.
            </p>
            <p className="privacy-note">
              <strong>Note:</strong> This policy covers website and general personal information, not your medical records. For details on how we protect your medical information (PHI), please see our HIPAA Notice of Privacy Practices.
            </p>
            
            <h2>1. Information We Collect</h2>
            <p>We collect two types of information:</p>
            
            <h3>Information you provide</h3>
            <p>This includes:</p>
            <ul>
              <li>Name</li>
              <li>Phone number</li>
              <li>Email address</li>
              <li>Insurance details (if entered)</li>
              <li>Billing or contact information</li>
              <li>Account details (if you create one)</li>
            </ul>
            
            <h3>Information collected automatically</h3>
            <p>Like most websites, we collect basic technical data such as:</p>
            <ul>
              <li>IP address</li>
              <li>Browser type</li>
              <li>Device type</li>
              <li>Pages visited</li>
              <li>Approximate location (based on your IP)</li>
            </ul>
            <p>We may use cookies or similar tools to improve your browsing experience and website performance.</p>
            
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Respond to your questions or appointment requests</li>
              <li>Provide and improve our website and services</li>
              <li>Send updates about your visit, billing, or urgent announcements</li>
              <li>Keep our website secure</li>
              <li>Understand how people use our site so we can improve it</li>
              <li>Send marketing emails only if you choose to receive them</li>
            </ul>
            <p>You may unsubscribe from marketing communications at any time.</p>
            
            <h2>3. How We Share Your Information</h2>
            <p>We do not sell your personal information.</p>
            <p>We may share information only with:</p>
            <ul>
              <li>Service providers who help us run our website or send messages</li>
              <li>Technology partners (e.g., website hosting, analytics tools)</li>
              <li>Advertising platforms (only if you accept marketing cookies)</li>
              <li>Legal authorities if required by law</li>
            </ul>
            <p>Any partners we work with must protect your information and use it only for permitted purposes.</p>
            
            <h2>4. Cookies & Tracking Tools</h2>
            <p>We use cookies and similar technologies to:</p>
            <ul>
              <li>Keep the site functioning</li>
              <li>Track website performance</li>
              <li>Improve user experience</li>
              <li>Show relevant ads (if you opt in)</li>
            </ul>
            <p>You can disable cookies in your browser settings, but some features may not work correctly.</p>
            
            <h2>5. How Long We Keep Your Information</h2>
            <p>We keep your information only as long as needed to:</p>
            <ul>
              <li>Provide services</li>
              <li>Meet legal requirements</li>
              <li>Maintain security</li>
            </ul>
            <p>When no longer needed, we delete it or securely store it until deletion is possible.</p>
            
            <h2>6. How We Protect Your Information</h2>
            <p>We use reasonable technical and organizational safeguards to protect your personal information.</p>
            <p>However, no website can guarantee 100% security. If you share information online, you do so at your own risk.</p>
            
            <h2>7. Children's Privacy</h2>
            <p>We do not knowingly collect information from children under 18 online.</p>
            <p>If you believe a child has provided information, please contact us to request removal.</p>
            
            <h2>8. Your Privacy Rights</h2>
            <p>Depending on your state or region, you may have the right to:</p>
            <ul>
              <li>Request access to the personal information we have about you</li>
              <li>Ask us to correct or delete it</li>
              <li>Opt out of marketing communications</li>
              <li>Restrict how certain sensitive information is used</li>
            </ul>
            <p>To exercise these rights, email <a href="mailto:bettercare@aspenquickcare.com" className="email-link">bettercare@aspenquickcare.com</a>.</p>
            
            <h2>9. Medical Information (HIPAA)</h2>
            <p>Your medical information is protected under HIPAA.</p>
            <p>Our Notice of Privacy Practices explains:</p>
            <ul>
              <li>How we use your medical information</li>
              <li>When it may be shared</li>
              <li>Your rights to access, update, or restrict it</li>
            </ul>
            <p>This website policy does not override HIPAA protections.</p>
            
            <h2>10. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time.</p>
            <p>The "Last Updated" date at the top will show when changes were made.</p>
            <p>By continuing to use the site, you accept the updated policy.</p>
            
            <h2>11. Contact Us</h2>
            <p>For privacy questions or requests, contact:</p>
            <address>
              <strong>Aspen Quick Care – Privacy Office</strong><br />
              Email: <a href="mailto:bettercare@aspenquickcare.com" className="email-link">bettercare@aspenquickcare.com</a>
            </address>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
